module.exports = __webpack_public_path__ + "img/about-img.e04bb7a0.png";